<div id="barrierefreiheitEinstellungenContainer">
  <strong>Einstellungen zur Barrierefreiheit</strong>
  <div id="titel">
    <mat-icon>accessibility</mat-icon>
    <span>Hier erhalten sie die Möglichkeit über verschiedenste Einstellungen ihre <br> persönliche Benutzerumgebung zu gestalten.</span>
  </div>
  <form id="content" [formGroup]="formGroup" *ngIf="formGroup">
    <mat-accordion>
      <mat-expansion-panel class="barrierefreiheitPanel" tabindex="0">
        <mat-expansion-panel-header>
          <div class="headerTitel">
            <span>Textgröße</span>
            <mat-icon *ngIf="textGroesse" [class.neu]="textGroesse == 'neu'" [class.aktiv]="textGroesse == 'aktiv'">{{ textGroesse == 'neu' ? 'edit' : 'check' }}</mat-icon>
          </div>
        </mat-expansion-panel-header>
        <barrierefreiheitTextanpassung (textGroesseAngepasst)="updateForm($event)"></barrierefreiheitTextanpassung>
      </mat-expansion-panel>
      <mat-expansion-panel class="barrierefreiheitPanel" *ngIf="environment.type == 'web'" tabindex="">
        <mat-expansion-panel-header>Tastenbelegung</mat-expansion-panel-header>
        <barrierefreiheitTastenbelegungAnsicht></barrierefreiheitTastenbelegungAnsicht>
      </mat-expansion-panel>
    </mat-accordion>
  </form>
  <div id="optionen" [class.wba]="environment.type != 'web'">
    <button mat-button (click)="barriereFreiehitService.barriereEinstellungenReset()">Einstellungen Zurücksetzen</button>
    <button mat-button (click)="barriereFreiehitService.barriereEinstellungenAbbrechen()">Abbrechen</button>
    <button mat-button (click)="barriereFreiehitService.barriereEinstellungenSpeichern()">Einstellungen Speichern</button>
  </div>
</div>
